import React from 'react';
import {
    NSCard, NSCheckbox, NSFormGroup,
} from 'bricks';
import { UnitMixRentRollData } from 'views/InvestmentMemo/types';
import RenderIf from 'components/RenderIf/RenderIf';
import InvestmentMemoUnitMixTable from './InvestmentMemoUnitMixTable/InvestmentMemoUnitMixTable';
import RentRollTable from './RentRollTable/RentRollTable';

interface Props {
    unitMixRentRoll: UnitMixRentRollData | null;
    onChange: (data: Partial<UnitMixRentRollData>) => void;
}

const UnitMixRentRoll = ({ unitMixRentRoll, onChange }: Props) => (
    <RenderIf isTrue={unitMixRentRoll}>
        {unitMixRentRoll && (
            <NSFormGroup>
                <div className="d-flex flex-column">
                    <NSCheckbox
                        id="include-unit-mix-rent-roll"
                        containerClassName="mb-3"
                        checked={unitMixRentRoll.include}
                        labelText={unitMixRentRoll.data.type === 'unit-mix' ? 'Include unit mix' : 'Include rent roll'}
                        callback={() => onChange({ include: !unitMixRentRoll.include })}
                    />
                    <RenderIf isTrue={unitMixRentRoll.include}>
                        <NSCard className="NSCard--level-3">
                            {unitMixRentRoll.data.type === 'unit-mix' && (
                                <InvestmentMemoUnitMixTable
                                    unitMixes={unitMixRentRoll.data.value}
                                    totals={unitMixRentRoll.data.totals}
                                />
                            )}
                            {unitMixRentRoll.data.type === 'rent-roll' && (
                                <RentRollTable
                                    tenants={unitMixRentRoll.data.value}
                                    totals={unitMixRentRoll.data.totals}
                                    isDataCenter={unitMixRentRoll.data.isDataCenter}
                                />
                            )}
                        </NSCard>
                    </RenderIf>
                </div>
            </NSFormGroup>
        )}
    </RenderIf>
);

export default UnitMixRentRoll;
